module.exports = __webpack_public_path__ + "media/bookPage/author-d5f9ef33.png";